import React from 'react'
import CourseDetailView from './CourseDetail'
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import { TableRowColumn, TableRow,} from 'material-ui/Table';

const style = {
    radioButtonGroup:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "center",
        marginTop:10,
        marginBlockStart:10,
    },
    radioButton: {
         maxWidth: 50,
    }
};

const radioButtonList = [
    {
        value: 1,
        label: "1"
    },
    {
        value: 2,
        label: "2"
    },
    {
        value: 3,
        label: "3"
    },
    {
        value: 4,
        label: "4"
    },
    {
        value: 5,
        label: "5"
    },
]


const  SessionCourse = (props)  => {

    return (
        <TableRow>
            <TableRowColumn colSpan="3">
                    <div style={{
                        display: 'flex',
                        flexFlow: 'row wrap',
                        justifyContent: "space-between"
                    }}>
                        <CourseDetailView courseTitle={props.availableCourseTitle}
                                        courseDetails={props.availableCourseDetails}
                                        courseInstructor={props.availableCourseInstructor}
                                        />
                        <RadioButtonGroup name={props.radioButtonGroupName}
                                        labelPosition="left" defaultSelected="not_light"
                                        style={style.radioButtonGroup}
                                        onChange={(event) => props.onRadioGroupChange( event.target.value)}>
                                    {
                                        radioButtonList.map((l, i) =>(
                                            <RadioButton
                                            key={i}
                                            value={l.value}
                                            label={l.label}
                                            style={style.radioButton}
                                        />
                                        ))
                                    }   
                        </RadioButtonGroup>
                    </div>
            </TableRowColumn>
       </TableRow>
    )
}

export default SessionCourse


// WEBPACK FOOTER //
// ./src/components/SessionCourse.jsx